export default __webpack_public_path__ + "static/2-28530207193d305cb9623b6a9bb6e284.jpg";